<template>
    <section :class="setClassProduct">
      <SpecificItemPage v-if="fotos && fotos.length > 0" :main-img="fotos[0].foto" :img-name="product.nombre">
        <template #grid-content>
          <DinamicGridImages :fotos="getObrasByProduct" />
        </template>
      </SpecificItemPage>
    </section>
</template>

<script>
import SpecificItemPage from '../components/SpecificItemPage.vue'
import ObrasService from '../services/ObrasService'
import DinamicGridImages from '../components/DinamicGrid/Images'
import ProductosService from '../services/ProductosService'
// import FamiliasProductosService from '../services/FamiliasProductosService'
export default {
  name: 'product page',
  components: {
    SpecificItemPage,
    DinamicGridImages
  },
  data () {
    return {
      id: this.$route.params.product.split('-')[0],
      title: this.$route.params.product.split('-')[1],
      color: this.$route.query.color,
      fotos: [],
      product: this.$route.query,
      obras: []
      // products: []
    }
  },
  computed: {
    setClassProduct () {
      return this.productSelected ? 'products-full-height' : 'products-page'
    },
    getObrasByProduct () {
      return this.obras.filter(obra => obra.productos.some(producto => producto.id === this.product.id))
    }
  },
  methods: {
    getProductById () {
      const serviceProduct = new ProductosService()
      serviceProduct.findById({ id: this.id }, response => {
        this.product = response
        this.fotos = response.fotos
      })
    },
    getObras () {
      const service = new ObrasService()
      service.findAll(null, (response) => {
        this.obras = response
      })
    }
    // getProductos () {
    //   const service = new FamiliasProductosService()
    //   service.findById({ }, (response) => {
    //     this.products = FamiliasProductosService.parse(response)
    //   })
    // }
  },
  mounted () {
    this.getProductById()
    this.getObras()
    // this.getProductos()
  }
}
</script>

<style lang="scss" scoped>
    .products-page {
      background: #1A1A1A;
    }
</style>
